export class RedirectToLoginError extends Error {
  loginUrl?: string;

  constructor(message?: string, loginUrl?: string) {
    super(message);

    this.loginUrl = loginUrl;
  }
}

export class RedirectToRootError extends Error {}

export class FormValidationError extends Error {}

/**
 * An error whose message is written for the user, so `withNotification`
 * shows it in place of its generic error text (e.g. a cbl-servc refusal
 * reason).
 */
export class NotificationError extends Error {}

export class CustomError extends Error {
  message: string = '';
  code: number;

  constructor(props: { message: string; code: number }) {
    super();

    this.message = props.message;
    this.code = props.code;
  }
}

export function isCustomError(
  error?: Error | CustomError
): error is CustomError {
  return error instanceof CustomError;
}

export function isRedirectToLoginError(
  error?: unknown | RedirectToLoginError
): error is RedirectToLoginError {
  return error instanceof RedirectToLoginError;
}
